import { Action, createReducer, on } from '@ngrx/store';
import { AuthState, AuthInitialState } from './auth.state';
import { AuthActions } from './auth.actions';

const _authReducer = createReducer(
  AuthInitialState,
  on(AuthActions.initQueryParams, state => ({ ...state, update: true })),
  on(AuthActions.setQueryParams, (state, { queryParams }) => ({
    ...state,
    queryParams,
  })),
  on(AuthActions.stopUpdate, state => ({ ...state, update: false }))
);

export function authReducer(state: AuthState, action: Action): AuthState {
  return _authReducer(state, action);
}
